import React, { forwardRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'

import { Bar } from 'react-chartjs-2'

import getReusableGraphOptions from '../reusableGraphOptions'

import { DEFAULT_GRAPH_COLOR } from '../../../../styles/themes/getDefaultTheme'

const BarGraph = forwardRef((props, ref) => {
  const { data, labels, className, graphColor, format } = props

  const theme = useTheme()

  const graphData = {
    labels,
    datasets: [
      {
        data: data,
        color: theme[DEFAULT_GRAPH_COLOR],
        backgroundColor: graphColor || theme[DEFAULT_GRAPH_COLOR],
        borderColor: graphColor || theme[DEFAULT_GRAPH_COLOR],
        borderRadius: 4,
        borderSkipped: false,
        maxBarThickness: 15
      }
    ]
  }

  const graphOptions = useMemo(
    () => getReusableGraphOptions({ format, graphColor, theme }),
    [format, graphColor, theme]
  )

  return (
    <div className={className}>
      <Bar type="bar" data={graphData} options={graphOptions} ref={ref} />
    </div>
  )
})

BarGraph.propTypes = {
  data: PropTypes.array.isRequired,
  labels: PropTypes.array,
  className: PropTypes.string,
  graphColor: PropTypes.string,
  format: PropTypes.string
}

export default BarGraph
